import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import MDButton from "components/MDButton";
import { Box, Button } from "@mui/material";
import { toast } from "sonner";
import placeholder from "../../../../assets/images/placeholder.png";
import { API_URL } from "../../../../config";

const AddHomePageProjectImage = ({ project, fetchHomepageProjects }) => {
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(
    project.photo || placeholder
  );
  const [imageFile, setImageFile] = useState(null);

  useEffect(() => {
    // Reset state on close
    if (!open) {
      setSelectedImage(project.photo || placeholder);
      setImageFile(null);
    }
  }, [open, project]);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (!["image/jpeg", "image/jpg", "image/png"].includes(file.type)) {
      toast.error("Please select a valid image file (jpeg, jpg, png).");
      return;
    }
    if (file) {
      setImageFile(file);
      setSelectedImage(URL.createObjectURL(file)); // Display the selected image
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!imageFile) {
      toast.error("Please select an image to upload.");
      return;
    }

    // FormData to handle image and other data
    const formData = new FormData();
    formData.append("projectImage", imageFile);

    try {
      // Replace with your API call for uploading data
      const response = await fetch(
        `${API_URL}/files/uploadProjectImage/${project.id}`,
        {
          method: "PATCH",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to upload image");
      }
      fetchHomepageProjects();
      toast.success("Success", {
        description: "Image added to project successfully",
      });
      handleClose();
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Box>
        <img
          src={selectedImage}
          alt={project.projectTitle}
          onClick={handleClickOpen}
          style={{
            width: "30px",
            height: "30px",
            objectFit: "cover",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        />
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: { padding: 20, borderRadius: 10 },
        }}
      >
        <DialogTitle>Add Academic Year & Image</DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" alignItems="center">
            {/* Preview Selected Image */}
            <img
              src={selectedImage}
              alt="Selected Preview"
              style={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                borderRadius: "8px",
                marginBottom: "10px",
              }}
            />
            {/* File Upload */}
            <Button
              variant="contained"
              component="label"
              style={{ marginBottom: "10px", color: "white" }}
            >
              Upload Image
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={handleImageChange}
              />
            </Button>
          </Box>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleClose}>Cancel</MDButton>
          <MDButton
            onClick={handleSubmit}
            variant="contained"
            color="info"
            disabled={!imageFile}
          >
            Submit
          </MDButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AddHomePageProjectImage;
